/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTEgMTZWMUgxNVYxMi43OTM2SDMuODIwOUwxIDE2Wk0yLjA0NDc4IDIuMTA5NDdWMTMuMjA0MUwzLjMwODk2IDExLjczOTZIMTMuOTU1MlYyLjEwOTQ3SDIuMDQ0NzhaIiBmaWxsPSJpbmhlcml0Ii8+";